import React, { useState } from "react";
import * as XLSX from "xlsx";
import apiClient from "../api/apiClient";


const UploadEscuelas = () => {
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleUpload = async () => {
        if (!file) {
            setError("Por favor, selecciona un archivo Excel.");
            return;
        }

        try {
            const reader = new FileReader();
            reader.readAsArrayBuffer(file);
            reader.onload = async (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: "array" });
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(sheet);

                // Formatear los datos según el formato esperado
                const formattedData = {
                    ContactEmployees: jsonData.map(row => ({
                        CardCode: row["Cod SN"],
                        InternalCode: row["Cod Escuela"],
                        Remarks2: String(row["Institucion"]),
                        U_Escuela: row["Nombre Completo"].normalize("NFKC"),
                        U_TipoIns: row["Tipo"]
                    }))
                };

                // Enviar los datos al backend
                const response = await apiClient.patch("/business-partners/contacts", formattedData);
                
                // Procesar la respuesta
                const { results } = response.data;
                const successCount = results.filter(r => r.status === "success").length;
                const warningCount = results.filter(r => r.status === "warning").length;
                const errorCount = results.filter(r => r.status === "error").length;

                let messageText = "";
                if (successCount > 0) {
                    messageText += `${successCount} SN actualizados con éxito.\n`;
                }
                if (warningCount > 0) {
                    messageText += `${warningCount} SN sin cambios.\n`;
                }
                if (errorCount > 0) {
                    messageText += `${errorCount} errores en la actualización.\n`;
                }

                setMessage(messageText);
                setError("");
                setFile(null);
                document.getElementById("fileUpload").value = "";

            };
        } catch (err) {
            setError("Error al procesar el archivo.");
            setMessage("");
        }
    };

    return (
        <div className="container mt-4">
            <h2>Cargar Lista de Escuelas</h2>
            {message && <div className="alert alert-success">{message}</div>}
            {error && <div className="alert alert-danger">{error}</div>}

            <div className="mb-3">
                <input type="file" id="fileUpload" className="form-control" accept=".xlsx" onChange={handleFileChange} />
            </div>
            <button className="btn btn-primary" onClick={handleUpload}>
                Subir y Actualizar SN
            </button>
        </div>
    );
};

export default UploadEscuelas;
